import { api } from '@api/api';
import { CompanyInviteDetailsResponse } from '@api/types/company-user/company-invite-details.response';
import { CompanyInviteDetailsRequest } from '@api/types/company-user/company-invite-details.request';
import { AcceptCompanyInviteRequest } from '@api/types/company-user/accept-company-invite.request';
import { CompanyUserResource } from '@api/types/company-user/company-user.resource';
import { Option } from '@api/types/option';
import { TypeAheadFilters } from '@api/types/type-ahead-filters';
import { refreshUserState } from '@store/user/user-slice';

const companyUserApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompaniesForCurrentUser: build.query<CompanyUserResource[], void>({
      query: () => ({
        url: 'companyuser',
      }),
      providesTags: ['CompanyUser'],
    }),
    getCompanyUsersOptions: build.query<Option[], TypeAheadFilters>({
      query: (params) => ({
        url: 'companyuser/options',
        params,
      }),
      providesTags: ['CompanyUser'],
    }),
    getCompanyInviteDetails: build.query<
      CompanyInviteDetailsResponse,
      CompanyInviteDetailsRequest
    >({
      query: (params) => ({
        url: 'companyuser/invite/details',
        params,
      }),
    }),
    acceptCompanyInvite: build.query<void, AcceptCompanyInviteRequest>({
      query: (body) => ({
        url: 'companyuser/invite/accept',
        method: 'POST',
        body,
      }),
      onCacheEntryAdded: async (_, { cacheDataLoaded, dispatch }) => {
        await cacheDataLoaded;
        dispatch(refreshUserState());
      },
    }),
  }),
});

export const {
  useGetCompanyInviteDetailsQuery,
  useGetCompanyUsersOptionsQuery,
  useGetCompaniesForCurrentUserQuery,
  useLazyGetCompanyUsersOptionsQuery,
} = companyUserApi;
